import { cn } from '@/lib/utils';
import { Search } from 'lucide-react';
import { KeyboardEvent, memo, useCallback, useState } from 'react';
import { z } from 'zod';
import { Input } from '../../ui/input';
import { TableFilterActionProps } from '../table-ag-types';

const TableFilterAction = (props: TableFilterActionProps) => {
    const { callback, inputProps = {} } = props;

    const [keyword, setKeyword] = useState<string>('');

    const onSearch = () => {
        callback?.(keyword ?? '');
    };

    const onEnterSearch = (e: KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            onSearch();
        }
    };

    return (
        <div className='relative max-w-[500px]'>
            <Input
                {...inputProps}
                className={cn('pr-8', inputProps.className)}
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                onKeyDown={onEnterSearch}
            />

            <Search
                className='absolute right-2.5 top-1/2 -translate-y-1/2 cursor-pointer'
                size={16}
                strokeWidth={2}
            />
        </div>
    );
};

export default memo(TableFilterAction);
